import React from 'react';
import PropTypes from 'prop-types';
import { Menu } from 'semantic-ui-react';
import _ from 'lodash';

import PopupMessage from 'PointOfSale/modules/common/container/PopupMessage';
import KeyboardInput from 'Common/Components/Keyboard/KeyboardInput';
import { withIgnoreKeypadInput } from './withIgnoreKeypadInput';

const KeyboardInputWithIgnoreKeypad = withIgnoreKeypadInput(KeyboardInput);

const TabMenus = props => {
  const {
    tabMenus,
    tabIcons,
    tabClickHandler,
    searchHandler,
    searchText,
    searchBox,
    disableSearch,
    loading,
    className,
    onKeyboardFocus,
    keyboardInputRef,
    onKeyboardBlur,
    ...rest
  } = props;
  return (
    <Menu className={className} {...rest}>
      {_.map(tabMenus, tab => (
        <Menu.Item
          key={tab.key}
          name={tab.label}
          active={tab.selected}
          onClick={() => !tab.disabled && tabClickHandler(tab)}
        />
      ))}

      <Menu.Menu position="right">
        {searchBox && (
          <Menu.Item>
            <KeyboardInputWithIgnoreKeypad
              className="icon transparent"
              icon="search"
              placeholder="Search..."
              disabled={disableSearch}
              value={searchText}
              onChange={searchHandler}
              loading={loading}
              usePortal
              onFocus={onKeyboardFocus}
              forwardedRef={keyboardInputRef}
            />
          </Menu.Item>
        )}
        {_.map(tabIcons, (item, index) => {
          return item.showPopup ? (
            <Menu.Item key={index}>
              <PopupMessage
                item={item}
                position={item.position}
                messageText={item.messageText}
                onConfirmClick={item.onClick}
              />
            </Menu.Item>
          ) : (
            <Menu.Item
              icon={item.icon}
              onClick={() => !item.disabled && item.onClick()}
              key={`${item.icon}${index}`}
            />
          );
        })}
      </Menu.Menu>
    </Menu>
  );
};

TabMenus.propTypes = {
  tabMenus: PropTypes.arrayOf(PropTypes.object),
  clickHandler: PropTypes.func,
  editButton: PropTypes.bool,
  resetButton: PropTypes.bool,
  editHandler: PropTypes.func,
};

TabMenus.defaultProps = {
  tabMenus: [],
  tabClickHandler: () => {},
  searchHandler: () => {},
  onKeyboardBlur: () => {},
  onKeyboardFocus: () => {},
};

export default TabMenus;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/common/component/TabMenus.js